import React from 'react'
import { DotsLoader, Text, Flex } from '@chilipiper/design-system'

interface Props {
  message: string
}

export const RouteGuestLoaderView = ({ message }: Props) => (
  <Flex height='100%' flexDirection='column' alignItems='center' justifyContent='center'>
    <DotsLoader color='neutral-dark-32' />
    <Text mt={4}>{message}</Text>
  </Flex>
)
